<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let partner = data?.partner;
	let award = data?.award;

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);


	});

	let isCollapseOneShown = true; // Default state
    let isCollapseTwoShown = false;

    // Function to toggle states
    const handleAccordionChange = (collapse: string) => {
        if (collapse === "one") {
            isCollapseOneShown = true;
            isCollapseTwoShown = false;
        } else if (collapse === "two") {
            isCollapseOneShown = false;
            isCollapseTwoShown = true;
        }
    };
</script>

<svelte:head>
	<title>Events - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="https://balinusadua.holidayinnresorts.com/en/events" />
</svelte:head>

<Navbar />

<FastBtn />

<section id="rooms">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<img alt="Holiday Inn Resorts Nusa Dua" src="/img/bg-header-event.webp" class="img-header" />
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100">
				<!-- <div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<h1 class="ff-lola-bir display-3 mb-3">Meeting & Events</h1>
					</div>
				</div> -->
			</div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-0 rooms-welcome position-relative">
		<div class="row g-0 justify-content-center mt-md-5 mt-4 mb-md-5 mb-5">
			<div class="col-md-10 px-md-5 px-3 text-center">
				<p class="mb-md-3 main-color display-5 pe-md-3 ff-lola-bir lh-2">{$_('event_title_1')}</p>
				<p class="line mb-md-4 mb-3 mx-auto"></p>
				<p class="ff-helvetica mb-md-4 mb-3">
					{$_('event_desc_1')}
				</p>
				<p class="ff-lola-r mb-md-4 mb-3">
					<a href="/file/MICE-Booklet-HIRBND.pdf" target="_blank" class="text-decoration-none main-color me-3"
						>{$_('event_btn_brochure')} <i class="ph-light ph-download-simple"></i></a
					>
				</p>
				<p class="text-center">
					<a href="mailto:ratu.ayu@ihg.com" target="_blank" class="btn main-btn px-4 py-2 rounded-3">{$_('event_btn_proposal')}</a>
				</p>
			</div>
		</div>
		<div class="row g-0">
			<div class="col-md-12 row g-0 py-md-5 align-items-stretch section-event-1 position-relative">
				<div class="col-md-6 offset-md-1 px-md-0 px-3">
					<div class="d-block d-md-none text-center">
						<div class="row g-0 align-items-center">
							<div class="col-1 nav-slider-event text-center">
								<span class="btn-prev main-color"><i class="ph ph-caret-left fs-4"></i></span>
							</div>
							<div class="col-10 text-center">
								<div class="swiper slider-event-header">
									<div class="swiper-wrapper">
										<div class="swiper-slide">
											<p class="mb-md-3 mb-1 main-color fs-1 pe-md-3 ff-lola-bir lh-2">{$_('event_list_title_1')}</p>
										</div>
										<div class="swiper-slide">
											<p class="mb-md-3 mb-1 main-color fs-1 pe-md-3 ff-lola-bir lh-2">
												{$_('event_list_title_2')}
											</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-1 nav-slider-event text-center">
								<span class="btn-next main-color"><i class="ph ph-caret-right fs-4"></i></span>
							</div>
						</div>
					</div>
					<div class="ratio ratio-16x9 d-none d-md-block">
						<img
							alt="Holiday Inn Resort Nusa Dua"
							src="/img/img-event-1.webp"
							class="w-100 h-100 object-fit-cover img-event-1"
							style="opacity: {isCollapseOneShown ? 1 : 0}; transition: opacity 0.3s;"
						/>
						<img
							alt="Holiday Inn Resort Nusa Dua"
							src="/img/social-event.webp"
							class="w-100 h-100 object-fit-cover img-event-2"
							style="opacity: {isCollapseTwoShown ? 1 : 0}; transition: opacity 0.3s;"
						/>
					</div>
					<div class="d-block d-md-none rounded-4">
						<div class="swiper slider-event-img">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="ratio-4x6 rounded-4">
										<img
											alt="Holiday Inn Resort Nusa Dua"
											src="/img/img-event-1.webp"
											class="w-100 h-100 object-fit-cover rounded-4"
										/>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="ratio-4x6 rounded-4">
										<img
											alt="Holiday Inn Resort Nusa Dua"
											src="/img/social-event.webp"
											class="w-100 h-100 object-fit-cover rounded-4"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-5 p-md-5 p-4 main-bg d-flex align-items-center">
					<div class="px-3 d-none d-md-block">
						<div class="accordion" id="accordionExample">
							<div class="accordion-item main-bg border-0 mb-3">
								<h2 class="accordion-header">
									<a
										class="text-decoration-none text-white fs-1 ff-lola-bir lh-2"
										role="button"
										data-bs-toggle="collapse"
										data-bs-target="#collapseOne"
										on:click={() => handleAccordionChange("one")}
                    					aria-expanded={isCollapseOneShown}
										aria-controls="collapseOne"
									>
									{$_('event_list_title_1')}
									</a>
								</h2>
								<div
									id="collapseOne"
									class="accordion-collapse collapse {isCollapseOneShown ? 'show' : ''}"
									data-bs-parent="#accordionExample"
								>
									<div class="accordion-body main-bg ps-md-0">
										<p class="ff-helvetica mb-3 text-white text-center text-md-start">
											{$_('event_list_desc_1')}
										</p>
										<p class="text-center text-md-start">
											<a
												href="mailto:ratu.ayu@ihg.com"
												target="_blank"
												class="btn btn-light px-4 py-2 rounded-3">{$_('btn_book')}</a
											>
										</p>
									</div>
								</div>
							</div>
							<div class="accordion-item main-bg border-0">
								<h2 class="accordion-header">
									<a
										class="text-decoration-none text-white fs-1 ff-lola-bir lh-2"
										role="button"
										data-bs-toggle="collapse"
										data-bs-target="#collapseTwo"
										on:click={() => handleAccordionChange("two")}
                    					aria-expanded={isCollapseTwoShown}
										aria-controls="collapseTwo"
									>
										{$_('event_list_title_2')}
									</a>
								</h2>
								<div
									id="collapseTwo"
									class="accordion-collapse collapse {isCollapseTwoShown ? 'show' : ''}"
									data-bs-parent="#accordionExample"
								>
									<div class="accordion-body ps-md-0">
										<p class="ff-helvetica mb-3 text-white text-center text-md-start">
											{$_('event_list_desc_2')}
										</p>
										<p class="text-center text-md-start">
											<a
												href="mailto:widiastuti.diah@ihg.com"
												target="_blank"
												class="btn btn-light px-4 py-2 rounded-3">{$_('btn_book')}</a
											>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="px-0 d-block d-md-none w-100">
						<div class="swiper slider-event-text">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<p class="ff-helvetica mb-3 text-white text-center text-md-start">
										{$_('event_list_desc_1')}
									</p>
									<p class="text-center text-md-start">
										<a
											href="mailto:ratu.ayu@ihg.com"
											target="_blank"
											class="btn btn-light px-4 py-2 rounded-3">{$_('btn_book')}</a
										>
									</p>
								</div>
								<div class="swiper-slide">
									<p class="ff-helvetica mb-3 text-white text-center text-md-start">
										{$_('event_list_desc_2')}
									</p>
									<p class="text-center text-md-start">
										<a
											href="mailto:widiastuti.diah@ihg.com"
											target="_blank"
											class="btn btn-light px-4 py-2 rounded-3">{$_('btn_book')}</a
										>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="container py-md-5 py-4 px-md-0 px-3">
		<div class="row g-0">
			<div class="col-md-6 pe-md-5 mb-3">
				<div class="card border-0 rounded-4" style="background: #F6F6F6;">
					<div class="card-body text-center p-md-5">
						<p class="mb-md-3 mb-1 main-color fs-1 pe-md-3 ff-lola-bir lh-2">Jati & Ebony</p>
						<p class="line mb-3 mx-auto"></p>
						<p class="ff-helvetica mb-3">
							{$_('event_type_info_1')}
						</p>
						<p class="mb-2">
							<span class="badge fs-6 fw-light secondary-badge ff-helvetica me-1 mb-2 px-4 py-2"
								><i class="ph-fill ph-users align-middle me-1"></i> {$_('event_type_occupancy_1')}</span
							>
						</p>
						<p class="mb-0">
							<a data-bs-toggle="modal" data-bs-target="#modalJati" class="btn main-btn px-4 py-2 btn-sm rounded-3" role="button">{$_('btn_view_details')}</a>
						</p>
					</div>
				</div>
			</div>
			<div class="col-md-6 ps-md-5 mb-3">
				<div class="card border-0 rounded-4" style="background: #F6F6F6;">
					<div class="card-body text-center p-md-5">
						<p class="mb-md-3 mb-1 main-color fs-1 pe-md-3 ff-lola-bir lh-2">Mahogany & Meranti</p>
						<p class="line mb-3 mx-auto"></p>
						<p class="ff-helvetica mb-3">
							{$_('event_type_info_2')}
						</p>
						<p class="mb-2">
							<span class="badge fs-6 fw-light secondary-badge ff-helvetica me-1 mb-2 px-4 py-2"
								><i class="ph-fill ph-users align-middle me-1"></i> {$_('event_type_occupancy_2')}</span
							>
						</p>
						<p class="mb-0">
							<a data-bs-toggle="modal" data-bs-target="#modalMahogany" class="btn main-btn px-4 py-2 btn-sm rounded-3" role="button">{$_('btn_view_details')}</a>
						</p>
					</div>
				</div>
			</div>
		</div>

		<!-- jati detail modal -->
		<div
			class="modal fade"
			id="modalJati"
			tabindex="-1"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-lg modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h1 class="modal-title fs-5" id="exampleModalLabel">Jati & Ebony</h1>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
						></button>
					</div>
					<div class="modal-body">
						{@html $_('event_type_desc_1')}
					</div>
				</div>
			</div>
		</div>
		
		<!-- mahogany detail modal -->
		<div
			class="modal fade"
			id="modalMahogany"
			tabindex="-1"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-lg modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h1 class="modal-title fs-5" id="exampleModalLabel">Mahogany & Meranti</h1>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
						></button>
					</div>
					<div class="modal-body">
						{@html $_('event_type_desc_2')}
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="container py-md-4 py-4">
		<div class="row g-0 justify-content-center">
			<div class="col-md-6 col-11">
				<img src="/img/layout-meeting-room.webp" class="img-fluid">
			</div>
		</div>
	</div>

	<div class="container featured-amenities py-md-5 py-4">
		<div class="row g-0 justify-content-center">
			<div class="col-md-10 text-center">
				<p class="mb-3 main-color display-5 pe-md-3 ff-lola-bir mt-md-5 lh-2">
					{$_('event_cover_title')}
				</p>
				<p class="line mb-md-5 mb-4 mx-auto"></p>
			</div>
			<div class="col-md-10 row g-0 justify-content-center">
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-speaker-high fs-5"></i>
					</div>
					<span class="main-color ff-lola-bir ms-1 lh-1">
						{$_('event_cover_list_1')}
					</span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-washing-machine fs-5"></i>
					</div>
					<span class="main-color ff-lola-bir ms-1 lh-1"> {$_('event_cover_list_2')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-coat-hanger fs-5"></i>
					</div>
					<span class="main-color ff-lola-bir ms-1 lh-1">
						{$_('event_cover_list_3')}
					</span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-address-book fs-5"></i>
					</div>
					<span class="main-color ff-lola-bir ms-1 lh-1"> {$_('event_cover_list_4')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-notepad fs-5"></i>
					</div>
					<span class="main-color ff-lola-bir ms-1 lh-1"> {$_('event_cover_list_5')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-wifi-high fs-5"></i>
					</div>
					<span class="main-color ff-lola-bir ms-1 lh-1">
						{$_('event_cover_list_6')}
					</span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-note-pencil fs-5"></i>
					</div>
					<span class="main-color ff-lola-bir ms-1 lh-1">
						{$_('event_cover_list_7')}
					</span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-package fs-5"></i>
					</div>
					<span class="main-color ff-lola-bir ms-1 lh-1"> {$_('event_cover_list_8')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-fork-knife fs-5"></i>
					</div>
					<span class="main-color ff-lola-bir ms-1 lh-1"> {$_('event_cover_list_9')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-printer fs-5"></i>
					</div>
					<span class="main-color ff-lola-bir ms-1 lh-1"> {$_('event_cover_list_10')} </span>
				</div>
			</div>
		</div>
	</div>
</section>

<Partner {partner} />

<Footer {award} />

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.rooms-welcome::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: -1;
		margin-bottom: -2px;
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 0.85),
				rgba(255, 255, 255, 0.8)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}
	.line {
		border-bottom: 2px solid #451C70;
		width: 25%;
	}
	.section-event-1::before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		width: 50%;
		height: 100%;
		background-color: #451C70;
		z-index: -1;
	}
	.featured-amenities .icon {
		background-color: #ebe5ef;
		color: #451C70;
		border-radius: 100%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	@media (max-width: 600px) {
		.rooms-welcome .right-content-rooms:before {
			content: unset;
		}
		.section-event-1::before {
			content: '';
			position: absolute;
			top: unset;
			bottom: 0;
			right: 0;
			width: 100%;
			height: 50%;
			background-color: #451C70;
			z-index: -1;
		}
	}
</style>
